import { render, staticRenderFns } from "./app-aside.vue?vue&type=template&id=5b7c2812&"
import script from "./app-aside.vue?vue&type=script&lang=js&"
export * from "./app-aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "app-aside.vue"
export default component.exports